import { combineReducers } from "redux";

import adminActions from "./admin/adminActions";
import tenantWideData from "./admin/tenantWideData";

export default combineReducers({
    adminActions,
    tenantWideData
});
